import * as yup from "yup";

// 사이트 생성 폼 유효성 검사 스키마
export const createServiceSiteSchema = (isDspProduct?: boolean) =>
  yup.object({
    urlPrefix: yup
      .string()
      .required("siteManagement.createSiteModal.placeholder.siteId")
      .min(2, "siteManagement.createSiteModal.min.urlPrefix")
      .max(20, "siteManagement.createSiteModal.max.urlPrefix")
      .when([], {
        is: () => isDspProduct,
        then: (schema) =>
          schema.matches(
            /^[a-z0-9-]+$/,
            "siteManagement.createSiteModal.alphaNumericDash"
          ),
        otherwise: (schema) => schema,
      })
      .test(
        "not-reserved-url-prefix",
        "siteManagement.createSite.prohibited",
        (value) => {
          if (!value) return true;
          const reserved = [
            "cloud",
            "management",
            "fwoc",
            "fireside",
            "admin",
            "support",
            "test",
          ];
          return !reserved.includes(value.toLowerCase());
        }
      ),
    product: yup.string().required("제품을 선택하세요."),
    region: yup.string().required("지역을 선택하세요."),
    serviceName: yup
      .string()
      .required("siteManagement.createSiteModal.placeholder.siteName")
      .max(20, "siteManagement.createSiteModal.max.serviceName"),
    serviceBillUid: yup.string(),
  });
